import {route} from "quasar/wrappers";
import {createMemoryHistory, createRouter, createWebHashHistory, createWebHistory, RouterHistory,} from "vue-router";

import routes from "./routes";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = selectCreateHistory();

  const router = createRouter({
    scrollBehavior: () => ({left: 0, top: 0}),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  router.beforeEach((to, from, next) => {
    if (to.meta.requiresAuth) {
      const token = sessionStorage.getItem("userId")
      if (token) {
        next();
      } else {
        const keycloakOptions = "/realms/club/protocol/openid-connect/auth?response_type=code&client_id=public&redirect_uri="
        const keycloakBaseUrl = import.meta.env.VITE_KEYCLOAK_BASE_URL ?? window.location.origin + "/auth";
        window.location.href = keycloakBaseUrl + keycloakOptions + window.location.origin;
      }
    } else {
      next();
    }
  });
  return router
});

function selectCreateHistory(): (base?: (string | undefined)) => RouterHistory {
  if (process.env.SERVER) {
    return createMemoryHistory;
  }
  if (process.env.VUE_ROUTER_MODE == "history") {
    return createWebHistory;
  }
  return createWebHashHistory;
}